import React, { Component } from 'react';
import axios from 'axios';
import StripeCheckout from 'react-stripe-checkout';
import { SUBSCRIBE_URL } from '../../config';
import DemoCard from '../../components/DemoCard/DemoCard';

import Header from '../../components/Header/Header';
import {
    STRIPE_PLANS,
    STRIPE_PUBLIC_KEY,
    TAX_RATE
} from './constants';

class Account extends Component {
    constructor(props) {
        super(props);

        this.state = {
            error: ''
        }
        if (!this.props.client) {
            this.props.updateClient();
        }
    }

    /**
     * Callback on payment through Stripe checkout componenet
     * @param {*} token created on payment
     * @param {*} plan chosen by user
     */
    onToken(token, plan) {
        let self = this;
        axios.post(
            SUBSCRIBE_URL(),
            {
                "email": token.email,
                "token": token.id,
                "plan": plan
            },
            {
                headers: {
                    "Authorization": self.props.client.token,
                    "Content-Type": "application/json"
                }
            }
        ).then(function (response) {
            self.props.updateClient();
            self.setState({ error: '' });
        }).catch(function (err) {
            self.setState({ error: err.response.data.msg });
        })
    }

    get header() {
        return (
            <Header
                pageName="ACCOUNT"
            />
        )
    }

    /**
     * Renders error message if one exists
     */
    get errorMessage() {
        if (!this.state.error || (this.state.error && (this.state.error.length == 0))){
            return null;
        }
        return (
            <div className="alert alert-danger" role="alert">
                There is an error with your subscription and we can not subscribe you at this time.
                Please try later or contact us in the chat box on the bottom right.
            </div>
        )
    }

    /**
     * Render pay button
     */
    renderPayButton(plan, price) {
        if (this.props.client && this.props.client.plan) {
            return null;
        }
    
            return (
                <StripeCheckout
                    token={token => this.onToken(token, plan)}
                    stripeKey={STRIPE_PUBLIC_KEY}
                    amount={price+price*TAX_RATE}
                    currency="CAD"
                >
                    <button className="btn btn-primary" id="PayButton">
                        Get Plan
                    </button>
                </StripeCheckout>
            );
    
    }

    /**
     * Renders the email associated with this account
     */
    get renderAccountEmail() {
        return (
            <div className="marginLine">
                <div className="formTitle">Email: </div> <div className="displayText">{this.props.client.email}</div>
            </div>
        )
    }

    /**
     * Renders card for Information on Enterprise Plan
     */
    get renderEnterprise() {
        return (
            <div className="row">    
                <div className="dashboardCard">
                    <div className="dashboardCardBody">
                        <p className="centered-row"> For more than 5 Locations, and other special plans, please contact us.</p>
                    </div>
                </div>
            </div>
        )
    }

    /**
     * Renders information about the user's subscription
     */
    get subscriptionExpiration() {
        return (
            <div className="marginLine">
                <div className="formTitle">Subscription Info:</div> {this.subscriptionExpirationDate}
            </div>
        )
    }

    /**
     * Renders expiration date
     */
    get subscriptionExpirationDate() {
        if (!this.props.client || !this.props.client.plan) return null;
        let dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        let expirationDate = new Date(this.props.client.subscriptionExpiry * 1000);
        let expiryDateString = expirationDate.toLocaleDateString('en-US', dateOptions);
        if (expiryDateString == "Invalid Date") {
            return (
                <div className="displayText">
                    You are currently on a custom payment plan. Contact us to know more about it.
          </div>
            )
        }
        return (
            <div className="displayText">
                Your account will be automatically charged on {expiryDateString}.
            </div>
        );
    }
    /**
     * Renders the info card about the account
     */
    get accountInfoCardRender() {
        if (this.props.client) {
            return (
                <div className="ThreebyFourcol" >
                    <div className="dashboardCard">
                        <div className="dashboardCardBody">
                            <div className="dashboardCardHeading">
                                Account Details
                            </div>
                            <div className="marginLine">
                                <div className="formTitle">Locations:</div> 
                                <div className="displayText">
                                        {this.props.client.locations.length}
                                </div>
                            </div>
                            <div className="marginLine">
                                <div className="formTitle">Plan:</div> 
                                <div className="displayText"> 
                                        {this.props.client.plan ? STRIPE_PLANS[this.props.client.plan - 1].name : "Free"}
                                </div>
                            </div>
                                {this.props.client.email ? this.renderAccountEmail : null}
                                {this.props.client.plan ? this.subscriptionExpiration : null}
                        </div>
                    </div>
                </div>
            )
        }
        else
            return null;
    }

    /**
     * Renders a payment option card
     * @param {Object} plan representing plan options 
     */
    renderPlanColumn(plan) {
        return (
            <div className="planCard" key={plan.name}>
                <div className="planCardBody">
                    <div className="planCardHeading">
                        {plan.name}
                    </div>
                    <div className="plan-content">
                        <div className="planCardIcon">
                            <img src={plan.img} width="130" />
                        </div>
                        <div className="money">${plan.price / 100} 
                            <span className="currency">
                                &nbsp; / yr + tax
                            </span>    
                        </div>
                        <div className="extraLocations">{plan.locations}</div>
                        <div className="features">
                            {plan.features.map((e, i) => <div key={i}>{e}</div>)}
                        </div>
                    </div>
                    {this.renderPayButton(plan.stripe_plan, plan.price)}
                </div>
            </div>
        )
    }

    /**
     * Renders each payment option card
     */
    get renderPlanColumns() {
        return (
            <div className="row" id="planRow">
                {STRIPE_PLANS.map(e => this.renderPlanColumn(e))}
            </div>
        )
    }

    render() {
        return (
            <div className="animated fadeIn">
                {this.header}
                <div className="pageContainer">
                    <div className="row">
                        {this.accountInfoCardRender}
                        <DemoCard/>
                    </div>
                    <div className="row">
                        <div className="dashboardCardHeading"> Get more from Honeycomb Premium</div>
                    </div>
                    <div className="row noMargin">
                        {this.errorMessage}
                    </div>                    
                    {this.renderPlanColumns}
                    {this.renderEnterprise}
                </div>
            </div>
        )
    }
}

export default Account;



// WEBPACK FOOTER //
// ./src/views/Account/Account.js